import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Multi-Theme`}</h2>
    <p>{`Legion uses multi-theming with the help of `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` from `}<a parentName="p" {...{
        "href": "https://theme-ui.com/guides/how-it-works#themeprovider"
      }}>{`Theme UI`}</a>{`, this means you can switch themes quickly and see what you need with as easy as props parsing to the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{`. With each theme from each tribe being loaded from a package, you are guaranteed to be updated as long as both designer and developer cooperated with any incoming updates to your application.`}</p>
    <br />
    <br />
    <h3><strong parentName="h3">{`ThemeProvider`}</strong></h3>
    <p>{`In this example we are going to use what’s generated from the `}<a parentName="p" {...{
        "href": "https://create-react-app.dev/"
      }}>{`Create React App`}</a>{` command, but the principal stays the same across entire application. You are going to edit your main root file of your React Js whether it’s `}<inlineCode parentName="p">{`App.js`}</inlineCode>{` or `}<inlineCode parentName="p">{`Index.js`}</inlineCode>{` or `}<inlineCode parentName="p">{`Main.js`}</inlineCode>{`, and wrap the entire Main Component / Main App with the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` such as follows with the props description:`}</p>
    <br />
    <br />
    <h3><strong parentName="h3">{`Props`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`theme`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The generated object from designer’s Figma pushed to the given repository, usually using 3 words of the given squad`}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <h3><strong parentName="h3">{`Available Themes`}</strong></h3>
    <p>{`Not all squad are also provided like tribe, some are ready for use some aren’t since needs will differ across platforms too. Here are the squads that are ready to use by order:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Theme Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Tribe / Squad Code`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Tribe / Squad Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme Agree`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`agl`}</inlineCode>{`, `}<inlineCode parentName="td">{`agr`}</inlineCode>{`, `}<inlineCode parentName="td">{`aqf`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Agree Livestock, Agree Culture, Agree Fisheries`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme Logee`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`lgd`}</inlineCode>{`, `}<inlineCode parentName="td">{`lgt`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Logee Distribution, Logee Transporation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme EDU`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`pjb`}</inlineCode>{`, `}<inlineCode parentName="td">{`pjm`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pijar Belajar, Pijar Mahir`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme ENT`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ptn`}</inlineCode>{`, `}<inlineCode parentName="td">{`oss`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Squad Pertamina, Squad OSS`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme EWZ`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`mcr`}</inlineCode>{`, `}<inlineCode parentName="td">{`mcn`}</inlineCode>{`, `}<inlineCode parentName="td">{`mtn`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`MyCarrier, mysooltan, MyTEnS`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme FIN`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`qip`}</inlineCode>{`, `}<inlineCode parentName="td">{`lpe`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Squad QIP, Squad Loyality Point Exchange`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme SMB`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`pdm`}</inlineCode>{`, `}<inlineCode parentName="td">{`lkp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Squad PaDi, Squad LKPP`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Theme VPL`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`pli`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Peduli Lindungi`}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <h3><strong parentName="h3">{`Installing Fonts Theme`}</strong></h3>
    <p>{`Latest steps you can install the fonts for your selected theme with embeded the font link innside your `}<inlineCode parentName="p">{`<head></head>`}</inlineCode>{` tag`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="Theme Agree" mdxType="AccordionItem">
        <p>{`Heading : `}<strong parentName="p">{`Montserrat`}</strong>{`, Body : `}<strong parentName="p">{`Open Sans`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Montserrat|Open+Sans" />
`}</code></pre>
      </AccordionItem>
      <AccordionItem title="Theme Logee" mdxType="AccordionItem">
        <p>{`Heading : `}<strong parentName="p">{`Ubuntu`}</strong>{`, Body : `}<strong parentName="p">{`Lato`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Ubuntu|Lato" />
`}</code></pre>
      </AccordionItem>
      <AccordionItem title="Theme EDU" mdxType="AccordionItem">
        <p><strong parentName="p">{`Pijar Belajar`}</strong>{` | Heading & Body : `}<strong parentName="p">{`Nunito`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Nunito" />
`}</code></pre>
        <br />
        <p><strong parentName="p">{`Pijar Mahir`}</strong>{` | Heading & Body : `}<strong parentName="p">{`Inter`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Inter" />
`}</code></pre>
      </AccordionItem>
      <AccordionItem title="Theme ENT" mdxType="AccordionItem">
        <p><strong parentName="p">{`Squad :`}</strong>{` PTN | Heading : `}<strong parentName="p">{`Poppins`}</strong>{`, Body : `}<strong parentName="p">{`Roboto`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Poppins|Roboto" />
`}</code></pre>
        <br />
        <p><strong parentName="p">{`Squad :`}</strong>{` OSS | Heading : `}<strong parentName="p">{`Poppins`}</strong>{`, Body : `}<strong parentName="p">{`Poppins`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Poppins" />
`}</code></pre>
      </AccordionItem>
      <AccordionItem title="Theme FIN" mdxType="AccordionItem">
        <p>{`Heading : `}<strong parentName="p">{`Plus Jakarta Sans`}</strong>{`, Body : `}<strong parentName="p">{`Inter`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans|Inter" />
`}</code></pre>
      </AccordionItem>
      <AccordionItem title="Theme VPL" mdxType="AccordionItem">
        <p>{`Heading : `}<strong parentName="p">{`Roboto`}</strong>{`, Body : `}<strong parentName="p">{`Roboto`}</strong></p>
        <br />
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto" />
`}</code></pre>
      </AccordionItem>
    </Accordion>
    <br />
    <br />
    <h3><strong parentName="h3">{`Usage Themes`}</strong></h3>
    <p>{`Below is the usage using Logee Transportation’s squad theme.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "filename=\"index.js\"",
        "filename": "\"index.js\""
      }}>{`import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { lgt } from '@legion-theme/logee';
import { ThemeProvider } from 'legion-ui';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={lgt}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
`}</code></pre>
    <p>{`After you wrap the main `}<inlineCode parentName="p">{`App`}</inlineCode>{` component inside the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{`, you’re all set and ready to go you can use any available components provided.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      